export default __webpack_public_path__ + "static/media/Draft_2-04.c187dbe6.png";